import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../site";

const items = [
  { src: IMAGES.hero, alt: "Candle-lit steam room at Relax Massage Spa Bur Dubai", cls: "md:col-span-7 aspect-[16/10]" },
  { src: IMAGES.lounge, alt: "Relaxation lounge at our massage spa in Bur Dubai, Dubai", cls: "md:col-span-5 aspect-[4/5] md:mt-16" },
  { src: IMAGES.stones, alt: "Hot stone massage therapy stones — Relax Massage Spa Dubai", cls: "md:col-span-5 aspect-[4/5] md:-mt-16" },
  { src: IMAGES.oils, alt: "Aromatherapy essential oils used for massage in Bur Dubai", cls: "md:col-span-7 aspect-[16/10]" },
];

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="max-w-7xl mx-auto px-6 md:px-10 py-28 md:py-40">
    <Reveal>
      <Overline>The Space</Overline>
      <h2 className="mt-6 font-serif font-light tracking-tight text-4xl sm:text-5xl md:text-6xl text-stone-100">
        Step <span className="italic text-gold-300">inside</span>
      </h2>
    </Reveal>
    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
      {items.map((item, i) => (
        <Reveal key={i} delay={i * 0.08} className={item.cls}>
          <div className="relative w-full h-full overflow-hidden rounded-sm group" data-testid={`gallery-image-${i}`}>
            <motion.img
              src={item.src}
              alt={item.alt}
              className="w-full h-full object-cover"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent opacity-60 group-hover:opacity-20 transition-opacity duration-700" />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
